import React from 'react';
import { useTabNavigationStore } from '../../store/tabNavigationStore';
import { ChevronLeft } from 'lucide-react';

interface BackButtonProps {
  /** Кастомный обработчик клика (по умолчанию popScreen()) */
  onClick?: () => void;
  /** Автоматически скрывать на корневых экранах (depth=1) */
  autoHide?: boolean;
  /** Дополнительные CSS классы */
  className?: string;
}

/**
 * BackButton - иконка стрелки "назад" для размещения рядом с заголовком
 * Использование: <div className="flex items-center gap-2"><BackButton /><h1>...</h1></div>
 */
export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  autoHide = false,
  className = '',
}) => {
  const { popScreen, getStackDepth } = useTabNavigationStore();

  // Автоматическое скрытие на корневых экранах
  if (autoHide && getStackDepth() <= 1) {
    return null;
  }

  const handleClick = () => {
    // Haptic feedback
    try {
      window.Telegram?.WebApp?.HapticFeedback?.impactOccurred('light');
    } catch {}

    if (onClick) {
      onClick();
    } else {
      popScreen();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center w-8 h-8 -ml-2 ${className}`}
      style={{ color: 'var(--accent)' }}
      aria-label="Назад"
    >
      <ChevronLeft size={24} strokeWidth={2} />
    </button>
  );
};
